function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "event-based-process",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.3807531,2 L14.7894707,4.37056171 C15.6342298,4.56220187 16.4273563,4.88979826 17.1446307,5.32913149 L19.0947278,3.95259229 L21.0474077,5.90527204 L19.6875912,7.83167877 C20.1478278,8.55664566 20.492705,9.36205285 20.6963955,10.2220736 L23,10.6192469 L23,13.3807532 L20.7165104,13.7744583 C20.5197608,14.6497253 20.1771146,15.4697969 19.7154528,16.2077919 L21.0474077,18.0947279 L19.0947278,20.0474078 L17.2077918,18.7154528 C16.4697968,19.1771147 15.6497253,19.5197609 14.7744582,19.7165104 L14.3807531,22 L11.6192469,22 L11.2220737,19.6963959 C10.3620529,19.4927049 9.55664563,19.1478279 8.83167876,18.6875912 L6.90527209,20.0474078 L4.95259227,18.0947279 L6.28856382,16.2035977 C7.59593968,15.6208091 8.58889131,14.4252988 8.91146694,13.0007142 L13,13 L13,17 L18,12 L13,7 L12.999,10.999 L8.91088436,11.0000626 C8.59225381,9.60585027 7.62300851,8.45092981 6.34364081,7.87472228 L4.95259227,5.90527204 L6.90527209,3.95259229 L8.8944024,5.35668422 C9.59874315,4.91878746 10.3773649,4.58910148 11.2070287,4.39086553 L11.6192469,2 L14.3807531,2 Z M4.5,9 C6.15685425,9 7.5,10.3431457 7.5,12 C7.5,13.6568542 6.15685425,15 4.5,15 C2.84314575,15 1.5,13.6568542 1.5,12 C1.5,10.3431457 2.84314575,9 4.5,9 Z",
  id: "Shape"
})));
function SvgProcess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess);
export default __webpack_public_path__ + "static/media/process.0a24cd27c1ce70a6b1de01506b6d7837.svg";
export { ForwardRef as ReactComponent };